<template>
  <div class="__custom_select" v-click-outside="clickOutsideEvent">
    <div
      class="__select"
      @click="showSelect = true"
      :class="disabled ? 'disabled_select' : ''"
    >
      <div class="__select_icon_search">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      <div class="__select_text">
        {{ chooseOption }}
      </div>
    </div>

    <span id="error" v-if="validateSelect != ''" class="is-invalid">
      {{ validateSelect }}
    </span>

    <template v-if="showSelect && !disabled">
      <div class="__options" ref="content">
        <div class="__options_search" @click="handleSelect()">
          <input
            class="__input"
            type="text"
            @input="search($event.target.value)"
            :placeholder="placeholder"
          />
        </div>

        <ul class="__options_items">
          <li 
            @click="showSelect = false"
            v-if="showADD"
          >
            <slot name="showADD"></slot>
          </li>
          <li v-if="list.length == 0 && !showOptionAddNew">Chưa có dữ liệu</li>
          <li v-if="showOptionAddNew">Không có kết quả</li>
          <li @click="removeValue" v-if="getVmodel != '' && !hideRemove">
            Bỏ chọn
          </li>
          <li
            v-for="(option, index) in list"
            :key="index"
            @click="changeValue(option)"
            :class="chooseOption === option.text ? '__option_selected' : ''"
          >
            <span>
                {{ `${option.text} - ` }}
            </span>
            <span class="inven-quantity">{{ ` Tồn hiện tại: ${option.quantity}` }}</span>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      validateSelect: this.validate,
      showSelect: false,
      showOptionAddNew: false,
      chooseOption: this.getVmodel != "" ? this.getVmodel : this.placeholder,
      // list là 1 mảng chứa danh sách prop 'option', các thao tác chức năng
      // của component này sẽ được xử lý qua list
      list: [],
      // khai báo listTmp để khi xoá search sẽ về danh sách ban đầu
      listTmp: [],
    };
  },

  model: {
    prop: "getVmodel",
    event: "value",
  },

  props: {
    variation: {
      value: Boolean,
      default: false
    },
    getVmodel: {
      value: String,
      default: "",
    },

    options: {
      value: Array,
      default: ["Chọn"],
    },

    placeholder: {
      value: String,
      default: "Chọn danh mục",
    },

    label: {
      value: String,
      default: "",
      require: true,
    },

    quantity: {
      value: Number,
      default: 0
    },

    hideRemove: {
      value: Boolean,
      default: false,
    },

    validate: {
      value: String,
      default: "",
    },

    disabled: {
      value: Boolean,
      default: false,
    },

    showADD: {
      value: Boolean,
      default: false,
    }
  },

  methods: {
    handleSelect() {
      this.showSelect = true
    },
    clickOutsideEvent() {
      this.showSelect = false;
      this.list = this.listTmp;
    },

    removeValue() {
      const value = { text: "" };
      value[this.label] = "";
      this.$emit("value", value[this.label]);
      this.$emit("select", value);
      this.chooseOption = "";
      this.showSelect = false;
    },

    beforeChangeValue(value) {
      this.validateSelect = "";
      this.$emit("select", this.chooseOption);
      this.showSelect = false;
    },

    // chọn 1 option và trả về kết quả lên component cha
    changeValue(value) {
      this.validateSelect = "";
      this.$emit("value", value[this.label]);
      this.$emit("select", value);
      // this.chooseOption = value.text
      this.showSelect = false;
    },

    // Tìm kiếm
    search(value) {
      if (this.variation) {
        const list = [...this.listTmp].filter(item => {
          return (
            item.text.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            item.upc.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            item.sku.toLowerCase().indexOf(value.toLowerCase()) !== -1
          )
        })
        this.list = list
      } else {
        const list = [...this.listTmp].filter(item => {
          return (
            item.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
          )
        })
        this.list = list
      }
      // nếu giá trị nhập không có , danh sách mặc định về ban đầu
      // if (value == "") {
      //   this.list = this.listTmp;
      //   this.showOptionAddNew = false;
      // } else {
      //   this.list = [];
      //   this.listTmp.find((e) => {
      //     // Trả về danh sách tìm kiếm được
      //     if (e[this.label].includes(value.trim())) {
      //       this.list.push(e);
      //     } else {
      //       // Trả về 'thêm mới' khi không có kết quả
      //       // this.showOptionAddNew = true
      //     }
      //   });
      // }
    },
  },

  watch: {
    // cập nhật lại danh sách Options khi danh sách truyền vào component có sự thay đổi
    options() {
      let result = this.options.map((e) => {
        return {
          ...e,
          quantity: e[this.quantity],
          text: e[this.label],
        };
      })
      this.list = result
      this.listTmp = result
    },
    validate() {
      this.validateSelect = this.validate;
    },

    getVmodel() {
      this.chooseOption =
      this.getVmodel != "" ? this.getVmodel : this.placeholder;
    },
  },
};
</script>

<style lang="scss" scoped>
.is-invalid {
  color: red;
}

.__custom_select {
  position: relative;
  width: 100%;

  select {
    display: none;
  }
  .fa-solid.fa-magnifying-glass {
    font-size: 18px;
  }
}
.__select {
  cursor: default;
  padding: 12px 32px 12px 15px;
  appearance: none;
  height: 44px;
  width: 100%;
  background: #fff;

  border: 1px solid #ddd;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;

  background: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.94 0.892578L4 3.94591L7.06 0.892578L8 1.83258L4 5.83258L0 1.83258L0.94 0.892578Z' fill='%23636678'/%3E%3C/svg%3E%0A")
    center right 16px no-repeat;

  cursor: pointer;

  &_icon_search {
    display: flex;
    align-items: center;
  }

  &_text {
    margin-left: 8px;
    color: #ACAEBB;
  }
}

.__options {
  position: absolute;
  z-index: 999999999;

  top: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #ddd;

  // border: 1px solid #3e69f6;
  overflow: hidden;
  border-radius: 4px;

  > ul.__options_items {
    margin: unset;
    padding: unset;
    border-top: 1px solid #ddd;

    max-height: 40vh;
    overflow-y: scroll;

    > li {
      padding: 12px 16px;
      cursor: pointer;
      color: #9093a4;

      &:hover {
        background: #3e69f61a;
        color: #3e69f6;
      }
      &:not(:first-child) {
        border-top: 1px solid #ddd;
      }
      &.__option_selected {
        background: #3e69f61a;
        color: #495057;
      }
    }

    &:hover {
      > li.__option_selected {
        background: transparent;
        &:hover {
          background: #3e69f61a;
          color: #495057;
        }
      }
    }
  }
}

.__options_search {
  width: 100%;
}

.inven-quantity {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #23313E;
}

.__input {
  flex: 1 1 100%;
  width: 100%;
  padding: 12px 16px;
  background: #ffffff;

  font-weight: 300;

  position: relative;

  &::placeholder {
    color: #c7c9d1;
  }
}

.disabled_select {
  background-color: #f2f3f4;
}
</style>
